import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Alignment } from 'roosterjs-editor-types';
import { setAlignment } from 'roosterjs-editor-api';

const alignRight: RibbonButton = {
    key: 'alignRight',
    title: () => strings.alignRight,
    imageSrc: require('../svg/alignright.svg'),
    onExecute: (plugin, logUsage) => {
        setAlignment(plugin.getEditor(), Alignment.Right);
        logUsage('setAlignment', Alignment.Right);
    },
};

export default alignRight;
